import { Match, Switch } from "solid-js";
import { CheckCircle2, Circle, List } from "@fleet/icons";
import { cn } from "@time-tracker/shared";
import type { SearchResult } from "./command-palette.types";

interface ResultItemProps {
  item: SearchResult;
  index: number;
  activeIndex: number;
  globalIndex: number;
  onSelect: () => void;
  onHover: (globalIndex: number) => void;
}

export function ResultItem(props: ResultItemProps) {
  const isActive = () => props.activeIndex === props.globalIndex;

  const itemIconColorClass = () => {
    if (props.item.type === "list") {
      return "bg-[color-mix(in_oklch,var(--primary)_12%,transparent)] text-[var(--primary)]";
    }
    if (props.item.completed) {
      return "bg-[color-mix(in_oklch,var(--muted)_50%,transparent)] text-[color-mix(in_oklch,var(--muted-foreground)_60%,transparent)]";
    }
    return "";
  };

  return (
    <button
      type="button"
      data-active={isActive()}
      class={cn(
        "flex items-center gap-2.5 w-full py-[9px] px-2.5 rounded-[10px] border-none bg-transparent cursor-pointer text-left transition-colors duration-80 ease-out text-foreground hover:bg-[color-mix(in_oklch,var(--accent)_70%,transparent)]",
        isActive() &&
          "bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)] active hover:bg-[color-mix(in_oklch,var(--primary)_10%,var(--accent)_60%)]",
      )}
      onClick={() => {
        props.onSelect();
      }}
      onPointerEnter={() => {
        props.onHover(props.globalIndex);
      }}
    >
      <span
        class={cn(
          "flex items-center justify-center w-7 h-7 rounded-lg shrink-0 bg-muted/80 text-muted-foreground transition-colors duration-80 ease-out",
          itemIconColorClass(),
        )}
      >
        <Switch fallback={<Circle class="h-4 w-4" />}>
          <Match when={props.item.type === "list"}>
            <List class="h-4 w-4" />
          </Match>
          <Match when={props.item.completed}>
            <CheckCircle2 class="h-4 w-4" />
          </Match>
        </Switch>
      </span>

      <span
        class={cn(
          "flex-1 text-[13.5px] font-[450] truncate tracking-[-0.01em]",
          Boolean(props.item.completed) && "line-through opacity-40",
        )}
      >
        {props.item.text}
      </span>

      <span class="text-[10px] font-semibold tracking-[0.04em] uppercase text-muted-foreground/50 shrink-0">
        {props.item.type === "list" ? "List" : "Task"}
      </span>
    </button>
  );
}
